var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecuritycheckinline = function SvgSecuritycheckinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "securitycheck_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".securitycheck_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "securitycheck_inline_svg__XMLID_8479_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "securitycheck_inline_svg__XMLID_8486_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "securitycheck_inline_svg__XMLID_8487_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "securitycheck_inline_svg__XMLID_8488_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "securitycheck_inline_svg__XMLID_8489_",
    d: "M23.2 11.5c-2.3 0-4.1 1.9-4.1 4.2s1.9 4.1 4.1 4.1 4.2-1.9 4.2-4.1-1.9-4.2-4.2-4.2zm0 6.4c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2z",
    className: "securitycheck_inline_svg__st1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "securitycheck_inline_svg__XMLID_8497_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "securitycheck_inline_svg__XMLID_8498_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "securitycheck_inline_svg__XMLID_8499_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "securitycheck_inline_svg__XMLID_8500_",
    d: "M32.3 24.7c-.5.5-1.2.9-1.8 1.2-.1-2.6-1.6-4.9-3.9-6.1l-.6-.3-2.8 2.8-2.8-2.8-.6.3c-2.4 1.3-3.9 3.8-3.9 6.5v10h13c1.6 1.7 3.4 2.3 3.4 2.3s5.8-1.9 5.8-8.8v-3.3c-.1 0-2.9.7-5.8-1.8zm-14.5 9.7v-8.1c0-1.8.9-3.4 2.3-4.4l3.1 3.1 3.1-3.1s.7.6.8.7c.2.3.5.5.6.8.4.6.6 1.3.8 1.9.1.4.1.7.1 1.1-.7.1-1.5.1-2.2 0v3.3c0 1.9.4 3.4 1.1 4.6l-9.7.1zm13.8-.4-2.5-2.6.7-.9 1.7 1.2 3.6-2.7.6.6-4.1 4.4z",
    className: "securitycheck_inline_svg__st1"
  }))))))));
};
export default SvgSecuritycheckinline;